import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import helper from './helper'
import { CONTENT_Y_DISTANCE } from './gsap-shared'

gsap.registerPlugin(ScrollTrigger)

window.$ourProcessLastIndex = 0

const animateAccordion = {
    $trigger: $('#process-accordion'),
    elements: $('.js-process-accordion-item'),
    titles: $('.js-process-accordion-title'),
    desktopImages: gsap.utils.toArray('.js-desktop-image img'),
    animationDuration: 7000,
    isNotDesktop: $(window).width() < 1025,
    isTablet: $(window).width() > 639,
    animationFreeze: false,
    animationStarted: false,
    processInterval: null,

    init: function () {
        let _this = this

        if (_this.$trigger.length) {
            if (_this.isTablet) {
                // Open the first accordion on init, so that it gets the .is-active class
                $('#process-accordion').foundation(
                    'down',
                    $(_this.elements[0]).find('.accordion-content')
                )
            }

            //Set all desktop images to be hidden on init
            gsap.set(_this.desktopImages, {
                x: CONTENT_Y_DISTANCE,
                opacity: 0,
            })

            //Animate into view the first desktop image
            $('.js-desktop-image img').show()
            gsap.set(_this.desktopImages[window.$ourProcessLastIndex], {
                x: 0,
                opacity: 1,
            })

            // AutoAnimate functionality for desktop and tablet
            // Keep adding 1, when you get to last element start from beginning
            const autoAnimate = () => {
                let index =
                    window.$ourProcessLastIndex < _this.titles.length - 1
                        ? window.$ourProcessLastIndex + 1
                        : 0
                $(_this.titles[index]).trigger('click')
            }

            // Check if click was done with mouse(freeze animation), or code(continue animating)
            _this.titles.on('click', e => {
                if (e.which) {
                    clearInterval(_this.processInterval)
                    _this.animationFreeze = true
                    _this.animationStarted = false

                    // Remove line animation if clicked with mouse
                    _this.elements.removeClass('animate')

                    // Set full orange line if clicked with mouse
                    $('.js-process-accordion-item.is-active').addClass(
                        'full-line'
                    )
                } else {
                    _this.animationFreeze = false
                    _this.animationStarted = true

                    // Remove form previous and animate line of active element
                    _this.elements.removeClass('animate')

                    $('.js-process-accordion-item.is-active').addClass(
                        'animate'
                    )
                }
            })

            // Fires when the tab is done opening.
            _this.$trigger.on('down.zf.accordion', () => {
                let index = $('.js-process-accordion-item.is-active').index()
                let animateImgTimeline = gsap.timeline({
                    repeat: 0,
                })

                let sectionPartiallyInView = helper.isElementInViewport(
                    $('.js-process-wrapper'),
                    'partialInView'
                )

                // Fade out the last desktop image and fade in the new one
                animateImgTimeline
                    .to(_this.desktopImages[window.$ourProcessLastIndex], {
                        x: CONTENT_Y_DISTANCE,
                        opacity: 0,
                        overwrite: true,
                    })
                    .to(_this.desktopImages[index], {
                        x: 0,
                        opacity: 1,
                        overwrite: true,
                    })

                // If animation wasn't frozen, haven't started and the section is partially visible, start animation
                if (
                    !_this.animationFreeze &&
                    !_this.animationStarted &&
                    sectionPartiallyInView
                ) {
                    _this.processInterval = setInterval(
                        autoAnimate,
                        _this.animationDuration
                    )
                    _this.animationStarted = true

                    $('.js-process-accordion-item.is-active').addClass(
                        'animate'
                    )

                    // Else if the entire section is out of the viewport, don't animate
                } else if (!sectionPartiallyInView) {
                    _this.animationStarted = false
                    clearInterval(_this.processInterval)

                    _this.elements.removeClass('animate')
                }

                // Set the old index to the lastly clicked one
                window.$ourProcessLastIndex = index

                //Fix - recalculates the position of GSAP markers on the page after the accordion opens
                ScrollTrigger.refresh(true)
            })

            $(window).on('scroll', () => {
                if (_this.isTablet) {
                    let sectionPartiallyInView = helper.isElementInViewport(
                        $('.js-process-wrapper'),
                        'partialInView'
                    )

                    // If the whole section is/gets out of the viewport, reset animation
                    if (!sectionPartiallyInView) {
                        _this.animationFreeze = false
                        _this.animationStarted = false
                        clearInterval(_this.processInterval)

                        // Remove full orange line if there was freeze
                        _this.elements.removeClass('full-line')

                        // Remove animating lines
                        _this.elements.removeClass('animate')
                    }

                    //If you scroll past the section, stop animating
                    if (
                        !sectionPartiallyInView &&
                        !_this.animationFreeze &&
                        _this.animationStarted
                    ) {
                        _this.animationStarted = false
                        clearInterval(_this.processInterval)

                        // Remove animating lines
                        _this.elements.removeClass('animate')
                    }

                    // If you were out of the section and scroll back to it, start animation
                    if (
                        sectionPartiallyInView &&
                        !_this.animationFreeze &&
                        !_this.animationStarted
                    ) {
                        _this.processInterval = setInterval(
                            autoAnimate,
                            _this.animationDuration
                        )
                        _this.animationStarted = true

                        // Animate the line
                        $('.js-process-accordion-item.is-active').addClass(
                            'animate'
                        )
                    }
                }
            })

            $(window).on('resize orientationchange', () => {
                let windowWidth = $(window).width()

                // Going from mobile to tablet
                if (windowWidth > 639 && _this.isTablet === false) {
                    _this.isTablet = true

                    //Set all desktop images to be hidden
                    gsap.set(_this.desktopImages, {
                        x: CONTENT_Y_DISTANCE,
                        opacity: 0,
                    })

                    //Fire the down event
                    $('#process-accordion').foundation(
                        'down',
                        $(_this.elements[window.$ourProcessLastIndex]).find(
                            '.accordion-content'
                        )
                    )
                }

                //Going from tablet to mobile
                if (windowWidth < 640 && _this.isTablet === true) {
                    _this.isTablet = false

                    // Stop auto animation when resizing
                    clearInterval(_this.processInterval)

                    // Reset if there was any freezing and the animation was started
                    _this.animationFreeze = false
                    _this.animationStarted = false

                    // Remove full orange line if there was freeze
                    _this.elements.removeClass('full-line')

                    //Remove animating of line
                    _this.elements.removeClass('animate')
                }

                // Going from tablet to desktop
                if (windowWidth > 1024 && _this.isNotDesktop === true) {
                    _this.isNotDesktop = false

                    // Reset animation, all freeze effects and start again
                    _this.animationFreeze = false
                    _this.animationStarted = false

                    clearInterval(_this.processInterval)

                    // Fire the down event
                    $('#process-accordion').foundation(
                        'down',
                        $(_this.elements[window.$ourProcessLastIndex]).find(
                            '.accordion-content'
                        )
                    )
                }

                // Going from desktop to tablet
                if (windowWidth < 1025 && _this.isNotDesktop === false) {
                    _this.isNotDesktop = true

                    // Reset animation, all freeze effects and start again
                    _this.animationFreeze = false
                    _this.animationStarted = false

                    clearInterval(_this.processInterval)

                    // Fire the down event
                    $('#process-accordion').foundation(
                        'down',
                        $(_this.elements[window.$ourProcessLastIndex]).find(
                            '.accordion-content'
                        )
                    )
                }
            })
        }
    },
}

animateAccordion.init()
